import React from 'react';
import {Outlet} from "react-router-dom";
const Contract = () => {
    return (
        <>
            <Outlet/>
        </>
    );
};

export default Contract;